// Paleta de gráficas coordinada con la línea gráfica institucional UNPHU.
export const CHART = {
  lst: "#e8620f",      // temperatura de superficie (cálido, semántico)
  ndvi: "#439441",     // verde principal UNPHU (Pantone 363 C)
  ndviDark: "#006837", // verde oscuro secundario (Pantone 349 C)
  lime: "#8cc63e",     // verde lima secundario (Pantone 368 C)
  navy: "#0f385a",     // azul secundario (Pantone 302 C)
  gray: "#9a999e",     // gris secundario (Pantone 424 C)
  grid: "#e9f1e7",
  axis: "#94a3b8",
};
